import { SxProps, Theme } from '@mui/material/styles';

const flowCardSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	width: '100%',
	boxSizing: 'border-box',
	padding: '10px 12px',
	border: '1px solid #E0EFFF',
	borderRadius: '4px',
	background: '#F4F9FF',
	color: '#2c2c2c',
	fontSize: '14px',
	lineHeight: '20px',
};

export const flowCardRowSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	color: '#0B6AD9',
};

export const flowPdpCardSX: SxProps<Theme> = {
	...flowCardSX,
	mt: '12px',
	width: { xs: '100%', md: 'fit-content' },
	maxWidth: '100%',
	height: { md: '35px' },
	py: { md: 0 },
	justifyContent: { md: 'center' },
	textAlign: 'left',
	cursor: 'pointer',
	alignItems: 'flex-start',
	'&:focus-visible': { outline: '2px solid #0B6AD9', outlineOffset: '2px' },
};

export const flowMiniCartCardSX: SxProps<Theme> = {
	...flowCardSX,
};

export const flowCartCardSX: SxProps<Theme> = {
	...flowCardSX,
};

export const flowInlineCardSX: SxProps<Theme> = {
	justifyContent: 'center',
	alignItems: 'flex-start',
	height: '35px',
	py: 0,
};
